// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { fontConfig } from "@vanmeter/XDL/constants";
import { color } from "@vanmeter/XDL/Utilities";
import React from "react";
import styled from "styled-components";

const LoadingContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-height: 280px;
    gap: 20px;
`;

const CompanyText = styled.div`
    font-size: 45px;
    font-weight: ${fontConfig.weight.bold};
    letter-spacing: 2px;
    color: ${color("text")};
    display: flex;
    gap: 4px;
`;

const Letter = styled.span<{ index: number }>`
    animation:
        letter-appear 0.6s ease-out forwards,
        letter-glow 1.5s ease-in-out infinite;
    opacity: 0;
    animation-delay: ${({ index }: any) => `${index * 0.15}s, ${index * 0.15}s`};

    @keyframes letter-appear {
        0% {
            opacity: 0;
            transform: scale(0.5);
        }
        100% {
            opacity: 1;
            transform: scale(1);
        }
    }

    @keyframes letter-glow {
        0%,
        100% {
            text-shadow: 0 0 0px ${color("text")};
        }
        50% {
            text-shadow: 0 0 10px ${color("text")};
        }
    }
`;

const CompanyNameSkeleton = ({ name }: { name: string }) => {
    const letters = name.split("");

    return (
        <LoadingContainer>
            <CompanyText>
                {letters.map((letter, index) => (
                    <Letter key={index} index={index}>
                        {letter}
                    </Letter>
                ))}
            </CompanyText>
        </LoadingContainer>
    );
};

export default CompanyNameSkeleton;
